import { useMemo, useRef } from "react";

import { useIntersectionObserver } from "@/hooks";
import { usePromptRegistryObjects } from "@/queries";

export const useRegistryData = (
  userToken: string,
  workspaceId: number,
  selectedReleaseLabel: string,
  selectedRegistryIds: number[],
) => {
  const ref = useRef<HTMLDivElement>(null);
  const entry = useIntersectionObserver(ref, {});

  const promptRegistryObjects = usePromptRegistryObjects(
    userToken,
    {
      workspaceId,
      promptLabelName: selectedReleaseLabel,
    },
    20,
  );

  const registryObjectsList = useMemo(
    () => promptRegistryObjects.data?.pages.flatMap(page => page.items) || [],
    [promptRegistryObjects.data],
  );

  const selectedRegistries = useMemo(
    () => registryObjectsList.filter(registry => selectedRegistryIds.includes(registry.id)),
    [registryObjectsList, selectedRegistryIds],
  );

  const availableRegistries = useMemo(
    () => registryObjectsList.filter(registry => !selectedRegistryIds.includes(registry.id)),
    [registryObjectsList, selectedRegistryIds],
  );

  if (entry?.isIntersecting && Boolean(selectedReleaseLabel)) {
    promptRegistryObjects.fetchNextPage();
  }

  return {
    ref,
    registryObjectsList: selectedReleaseLabel ? registryObjectsList : [],
    selectedRegistries: selectedReleaseLabel ? selectedRegistries : [],
    availableRegistries: selectedReleaseLabel ? availableRegistries : [],
    hasNextPage: selectedReleaseLabel ? promptRegistryObjects.hasNextPage : false,
  };
};
